import { testimonials } from '../../../mocks/testimonials';

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <span className="inline-block px-6 py-2 bg-orange-100 text-orange-700 text-sm font-semibold rounded-full mb-4">
            Reviews
          </span>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            What Our Customers<br />Are Saying
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 flex items-center justify-center text-white font-bold text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="ml-4">
                  <h4 className="text-base font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-500">@{testimonial.username}</p>
                </div>
              </div>
              <div className="flex mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
                {[...Array(5 - testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-line text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                "{testimonial.review}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
